import { IUsageResultGrade } from "../../models/usage-analytics/IUsageResult";


type ColourModifier = "red" | "amber" | "green" | "blue" | "grey";

export const gradeToStatusColour = (grade: IUsageResultGrade): ColourModifier => {
    switch (grade) {
        case "Emerging":
            return "red";
        case "Engaged":
            return "amber";
        case "Empowered":
            return "green"
        case "Excelling":
            return "blue";
        default:
            return "grey"
    }
}

export const gradeToPieChartColour = (grade: IUsageResultGrade): string => {
    switch (grade) {
        case "Emerging":
            return "#cc3232";
        case "Engaged":
            return "#e7b416";
        case "Empowered":
            return "#99c140"
        case "Excelling":
            return "#0085F6";
        default:
            return "#e3e3e3"
    }
}
